import { useEffect, useState } from "react";
import { useAuth } from "../../providers/authprovider";
import { Button, Table } from "react-bootstrap";
import AddWorkerModal from "./AddWorkerModal";
import { ControlledMenu, MenuItem, useMenuState } from "@szhsin/react-menu";
import EditPrevilagesModal from "./EditPrevilagesModal";
import EditUserTrainingsModal from "./EditUserTrainingsModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

export default function Workers(props) {
  const { privilege } = props;
  const { users } = useAuth();
  const [workers, setWorkers] = useState(undefined);
  const [departments, setDepartments] = useState([]);
  const [showAddWorkerModal, setShowAddWorkerModal] = useState({
    show: false,
    worker: undefined,
  });

  useEffect(() => {
    if (workers === undefined) {
      users.get((response) => {
        if (response.success) {
          console.log(response.content);
          setWorkers(response.content);
        }
      });
      return;
    }
  });

  useEffect(() => {
    users.getDepartments(({ success, content }) => {
      if (success) setDepartments(content || []);
    });
  }, [users]);

  const handleAddWorker = () => {
    setShowAddWorkerModal({ show: true, worker: undefined });
  };

  const handleHideModal = () => {
    setShowAddWorkerModal({ show: false, worker: undefined });
  };

const handleSaveWorker = (worker) => {
  setWorkers((prev) => {
    const existingIndex = prev.findIndex((c) => c.id === worker.id);

    if (existingIndex > -1) {
      return prev.map((w, i) => (i === existingIndex ? { ...w, ...worker } : w));
    }

    return [...prev, worker];
  });

  setShowAddWorkerModal({ show: false, worker: undefined });
};

  const handleWorkerDeletion = (worker) => {
    users.remove(worker.id, ({ success, error, content }) => {
      if (!success) return window.alert(error);

      setWorkers((prev) => {
        return prev.filter((w) => w.id !== worker.id);
      });
    });
  };

  const handleEditWorker = (worker) => {
    setShowAddWorkerModal({ show: true, worker: worker });
  };

  return (
    <div className={"container"}>
      {privilege.edit && (
        <Button className={"m-2 float-end"} onClick={handleAddWorker}>
          Dodaj pracownika
        </Button>
      )}
      {showAddWorkerModal.show && (
        <AddWorkerModal
          show={true}
          worker={showAddWorkerModal.worker}
          departments={departments}
          onHide={handleHideModal}
          onSave={handleSaveWorker}
        />
      )}
      {workers && (
        <WorkersList
          workers={workers}
          departments={departments}
          privilege={privilege}
          onEditWorker={handleEditWorker}
          onWorkerChanged={handleSaveWorker}
          onDeleteWorker={handleWorkerDeletion}
        />
      )}
    </div>
  );
}

function WorkersList(props) {
  const {
    workers,
    departments,
    onEditWorker,
    privilege,
    onWorkerChanged,
    onDeleteWorker,
  } = props;
  const [menuProps, toggleMenu] = useMenuState();
  const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
  const [currentContextWorker, setCurrentContextWorker] = useState(undefined);
  const [previlagesModal, setPrevilagesModal] = useState({
    show: false,
    worker: undefined,
  });
  const [trainingsModal, setTrainingsModal] = useState({
    show: false,
    worker: undefined,
  });
  const { user } = useAuth();

  const handleWorkerContextMenu = (e, worker) => {
    e.preventDefault();
    setAnchorPoint({ x: e.clientX, y: e.clientY });
    toggleMenu(true);
    setCurrentContextWorker(worker);
  };

  const handleEditWorker = () => {
    if (currentContextWorker !== undefined) onEditWorker(currentContextWorker);
  };

  const handleEditPrevilages = (worker) => {
    setPrevilagesModal({ show: true, worker: worker });
  };

  const hidePrevilagesModal = () => {
    setPrevilagesModal({ show: false, worker: undefined });
  };

  const handleEditTrainings = (worker) => {
    setTrainingsModal({ show: true, worker: worker });
  };

  const hideTrainingModal = (userTrainingsData) => {
    const { user_id, trainings } = userTrainingsData;
    setTrainingsModal({ show: false, worker: undefined });

    const worker = workers.find((w) => w.id === user_id);

    if (worker !== undefined) {
      worker.trainings = trainings;
      onWorkerChanged(worker);
    }
  };

  const workerTrainings = (worker) => {
    if (worker.trainings === undefined) return;

    return worker.trainings
      .sort((a, b) => {
        return (
          new Date(a.expiration_date).getTime() -
          new Date(b.expiration_date).getTime()
        );
      })
      .map((training, index) => {
        const date = new Date(training.expiration_date);
        const bg = getExpirationBgColor(training);
        return (
          <span
            key={index}
            className={`m-1 cursor-pointer border-1 ${bg} rounded p-1`}
            title={training.name}
          >
            {date.toLocaleDateString()}
          </span>
        );
      });
  };

  const departmentName = (code) => {
    if (!code) return "";

    const department = (departments || []).find(
      (item) => item.code.toUpperCase() === code.toUpperCase(),
    );

    return department ? department.name : code;
  };

  const henldeDeleteWorker = () => {
    if (!currentContextWorker) return;

    if (
      !window.confirm(
        "Potwierdź usunięcie pracownika: " + currentContextWorker.name,
      )
    )
      return;

    onDeleteWorker(currentContextWorker);
  };

  return (
    <>
      {privilege.edit && (
        <ControlledMenu
          {...menuProps}
          anchorPoint={anchorPoint}
          onClose={() => toggleMenu(false)}
        >
          <MenuItem onClick={handleEditWorker}>Edytuj</MenuItem>
          {user.isAdmin && (
            <MenuItem onClick={henldeDeleteWorker}>Usuń</MenuItem>
          )}
        </ControlledMenu>
      )}

      <Table className={"m-2"} size={"sm"} striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th></th>
            <th>Imię i nazwisko</th>
            <th>Numer tel</th>
            <th>SMS</th>
            <th>Email</th>
            <th>Oddział</th>
            <th>Stanowisko</th>
            <th>Login</th>
            <th>Szkolenia</th>
            <th>Akcje</th>
          </tr>
        </thead>
        <tbody>
          {workers &&
            workers.map((worker, lp) => {
              return (
                <tr
                  key={worker.id}
                  onContextMenu={(e) => handleWorkerContextMenu(e, worker)}
                  className={`worker-${worker.active ? "active" : "inactive"}`}
                >
                  <td>{lp + 1}</td>
                  <td>
                    <LastLoginTime
                      privilege={privilege}
                      date={worker.lastLoginTime}
                    />
                  </td>
                  <td>{worker.name}</td>
                  <td>
                    <div style={{ whiteSpace: "nowrap" }} >
                      {worker.tel} 
                      
                    </div>
                  </td>
                  <td>
                    {
                        worker.verifyWithSms == 1 && (
                            <FontAwesomeIcon className="text-success" icon={faCircleCheck} title="Logowanie dwuetapowe z autoryzacją SMS jest włączone" />
                        )
                      }
                      </td>
                  <td>{worker.email}</td>
                  <td>{departmentName(worker.department)}</td>
                  <td>{worker.position}</td>
                  <td>{worker.login}</td>
                  <td>
                    <div className={"trainingsBox"}>
                      {workerTrainings(worker)}
                    </div>
                  </td>
                  <td>
                    <div className={"actionBtnBox"}>
                      <Button
                        size={"sm"}
                        variant={"outline-info"}
                        onClick={() => handleEditTrainings(worker)}
                      >
                        Szkolenia
                      </Button>
                      <Button
                        size={"sm"}
                        className={"ms-2"}
                        variant={"outline-success"}
                        onClick={() => handleEditPrevilages(worker)}
                      >
                        Uprawnienia
                      </Button>
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
      {previlagesModal.show && (
        <EditPrevilagesModal
          privilege={privilege}
          worker={previlagesModal.worker}
          onHide={hidePrevilagesModal}
        />
      )}
      {trainingsModal.show && (
        <EditUserTrainingsModal
          privilege={privilege}
          worker={trainingsModal.worker}
          onHide={hideTrainingModal}
        />
      )}
    </>
  );
}

function LastLoginTime({ date, privilege }) {
  if (privilege.edit === false) return null;

  let timeSpan = 0;
  let currentTime = Date.now();

  if (date !== null && date !== undefined)
    timeSpan =
      new Date(date).getTime() + new Date(date).getTimezoneOffset() * 60 * 1000;

  let diffTime = (currentTime - timeSpan) / 1000;
  const DAY_SEC = 24 * 3600;
  const HOUR_SEC = 3600;
  const MIN = 60;

  const timeFromLoginOnHours = diffTime / HOUR_SEC;

  const daysAgo = (diffTime - (diffTime % DAY_SEC)) / DAY_SEC;
  diffTime = diffTime - daysAgo * DAY_SEC;
  const hoursAgo = (diffTime - (diffTime % HOUR_SEC)) / HOUR_SEC;
  diffTime = diffTime - hoursAgo * HOUR_SEC;
  const minutesAgo = (diffTime - (diffTime % MIN)) / MIN;

  let bg = "bg-light";
  if (timeFromLoginOnHours > 60 * 24) {
    bg = "bg-light";
  } else if (timeFromLoginOnHours > 72) bg = "bg-danger";
  else if (timeFromLoginOnHours > 24) bg = "bg-warning";
  else bg = "bg-success";
  let lastLoginInfo = "Uzytkownik nie logował się przez ostatnie 2 miesiące.";

  if (date !== null) {
    lastLoginInfo = `ostatnio logował się `;
    lastLoginInfo += daysAgo > 0 ? `${daysAgo}d, ` : ``;
    lastLoginInfo += hoursAgo > 0 ? `${hoursAgo}h, ` : ``;
    lastLoginInfo += ` ${minutesAgo}min temu o godz. ${date}`;
  }

  return <span className={`${bg} lastLoginbadge`} title={lastLoginInfo}></span>;
}

export function getExpirationBgColor(training) {
  const currentTime = new Date().getTime();
  const date = new Date(training.expiration_date);
  const expirationTime = date.getTime();
  let bg = "bg-light";

  const timeToExpiration = (expirationTime - currentTime) / 1000;

  const bgYellowAlert = 60 * 60 * 24 * 30; //alert color in 30 day before expiration
  const bgRedAlert = 60 * 60 * 24 * 7; //alert color in 7 day before expiration

  if (timeToExpiration <= bgRedAlert) {
    bg = "bg-danger";
  } else if (timeToExpiration <= bgYellowAlert) {
    bg = "bg-warning";
  }

  return bg;
}
